import { AxiosPromise } from 'axios';
import { ResponseDefault } from '@app/typings/services/service.d';
import { BatteryData } from './battery';
import { PaginationParams } from '@app/typings/default';
import { EvLockerInfo } from './logs';

export enum EvLockerType {
  NIU = 'niu',
  STROM = 'strom',
}

export enum EvLockerStatus {
  EMPTY = 'empty',
  FAILED = 'failed',
  INACTIVE = 'inactive',
  CHARGING = 'charging',
  CHARGED = 'charged',
  RESERVED = 'reserved',
  PENDING = 'pending',
}

export enum EvLockerAction {
  ACTIVATE = 'activate',
  CANCEL = 'cancel',
  GET_UPDATE = 'get-update',
  INACTIVATE = 'inactivate',
  INSERT = 'insert',
  MAINTAIN = 'maintain',
  OPEN = 'open',
  RESERVE = 'reserve',
  TAKEOUT = 'takeout',
  SEND_UPDATE = 'send-update',
}

export enum EvLockerActionStatus {
  FAILED = 'failed',
  SUCCESS = 'success',
}

export interface EvLockerSearchParams {
  from?: string;
  to?: string;
  projectIds?: string[];
  statuses?: string[];
  serialNumber?: string;
  lockerNumber?: number;
}

export interface FilterEvLockers {
  filters?: EvLockerSearchParams;
  pages: PaginationParams;
}

export interface EvLockersData {
  _id: string;
  batteriesInfo?: BatteryData[];
  currentBatteries?: BatteryData[];
  enabled: boolean;
  status: EvLockerStatus;
  projectId: string;
  projectName: string;
  lockerNumber: number;
  batteries: string[];
  createdAt: string;
  updatedAt: string;
  transactionInfo: TransactionInfo;
  inactiveReason: string;
  type?: EvLockerType;
}

export interface TransactionInfo {
  action: EvLockerAction;
  actionBy: string;
  actionAt: string;
  actionStatus: EvLockerActionStatus;
  jobId: string;
}

export interface ReasonWinnonieData {
  description: string;
  level: boolean;
  name: string;
  value: string;
}

export interface EvLockersPaymentData {
  _id: string;
  updatedBy: string;
  createdBy: string;
  stopDateTime: string;
  startDateTime: string;
  participantIds: string[];
  courierTrackingCodes: string[];
  status: string;
  ownerId: string;
  assetType: string;
  assetId: string;
  zoneId: string;
  projectId: string;
  brandId: string;
  createdAt: string;
  updatedAt: string;
  createdByObjectId: string;
  updatedByObjectId: string;
  userInfo?: {
    email?: string;
    phone?: string;
    profileName?: string;
    firstName?: string;
    lastName?: string;
  };
  payment: {
    amount: string;
    paymentType: string;
  }[];
  locker: {
    size: string;
    lockerNumber: number;
    status: string;
  };
  zoneName: string;
  durationHour: number;
  durationMin: number;
  checkIn: number;
  checkOut: string | null;
}

interface EvLockerActionData {
  evLocker: EvLockerInfo;
  id: string;
  successful: boolean;
}
interface EvLockerResponse extends ResponseDefault {
  data: EvLockersData[];
}
interface EvLockersPaymentResponse extends ResponseDefault {
  data: EvLockersPaymentData[];
}

interface EvLockerActionResponse extends ResponseDefault {
  data: EvLockerActionData;
}
export interface FetchEvLockersParams {
  offset?: number;
  limit?: number;
  projectIds?: string;
  statuses?: string;
  serialNumber?: string;
  lockerNumber?: number;
}

export interface ActionEvLockerParams {
  action: string;
  reason?: string;
  isBrandLevel: boolean;
}

export interface FetchEvLockersPaymentParams {}

export type FetchEvLockers = (params: FilterEvLockers) => AxiosPromise<EvLockerResponse>;
export type FetchEvLockersPayment = (
  zoneId?: string | null,
  text?: string,
  startDate?: string,
  endDate?: string,
  offset?: number,
) => AxiosPromise<EvLockersPaymentResponse>;

interface UpdateEvLockerResponse extends ResponseDefault {
  data: EvLockersData;
}
interface ReasonResponse extends ResponseDefault {
  data: ReasonWinnonieData[];
}

export type ActionEvLocker = (
  lockerId: string | string[],
  action: string,
  reason?: string,
) => AxiosPromise<EvLockerActionResponse>;

export type ActionEvLockerPayment = (paymentID: string) => AxiosPromise<UpdateEvLockerResponse>;
export type ReasonWinnonie = (type: string) => AxiosPromise<ReasonResponse>;
